
import Index from '~/pages/blog/index'
export default Index
